module.exports = __webpack_public_path__ + "static/media/get-our-app.7152c001.svg";